import React from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { easings, useSpring } from '@react-spring/web';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { AnimatedBox } from '../AnimatedComponents/AnimatedView';

interface IOnHoverAnimator {
    isHovered: boolean;
    title?: string;
    onActionPress?: () => void;
    sxContainer?: SxProps<Theme>;
}
const OnHoverAnimator: React.FC<IOnHoverAnimator> = ({ isHovered, title, onActionPress, sxContainer }): any => {
    const { themeStyle } = useThemeContext();
    const scaleAnimation = useSpring({
        transform: `scale(${isHovered ? 1.4 : 1})`,
        backgroundColor: theme[themeStyle].highlight,
        width: 'fit-content',
        height: 20,
        padding: 10,
        top: '50%',
        left: '50%',
        display: 'flex',
        borderRadius: 10,
        config: {
            duration: 300,
            easing: easings.linear,
        },
    });

    const renderOutput = isHovered ? (
        <Box
            style={{
                backgroundColor: 'rgba(0,0,0,0.5)',
                position: 'absolute',
                zIndex: 999,
                width: '100%',
                height: '100%',
            }}>
            <AnimatedBox
                style={scaleAnimation}
                onClick={onActionPress}
                sx={{
                    width: '100%',
                    height: '100%',
                    marginTop: '35%',
                    marginLeft: '40%',
                    cursor: 'pointer',
                    ...sxContainer,
                }}>
                <Typography
                    style={{
                        fontFamily: FONT_ENUM.REGULAR_HEADER,
                        fontSize: 6,
                        alignSelf: 'center',
                        color: theme[themeStyle].gray_text,
                        textTransform: 'uppercase',
                    }}>
                    {title ?? 'open'}
                </Typography>
            </AnimatedBox>
        </Box>
    ) : null;
    return renderOutput;
};

export { OnHoverAnimator };
